type AlertVariant = 'success' | 'error';

interface AlertProps {
  variant: AlertVariant;
  children: React.ReactNode;
  className?: string;
}

const VARIANT_STYLES: Record<AlertVariant, { container: string; icon: string }> = {
  success: {
    container: 'bg-tutela-growth/10 border border-tutela-growth/30 text-tutela-growth',
    icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
  },
  error: {
    container: 'bg-risk-high/10 border border-risk-high/30 text-risk-high',
    icon: 'M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  },
};

export default function Alert({ variant, children, className = '' }: AlertProps) {
  const styles = VARIANT_STYLES[variant];
  return (
    <div className={`${styles.container} rounded-xl p-4 text-sm flex items-center gap-2 ${className}`}>
      <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={styles.icon} />
      </svg>
      {children}
    </div>
  );
}
